/**
 * 标题建议的埋点处理
 * 详情看埋点部分：https://bytedance.feishu.cn/docs/doccna52cTgVsyfakZfsu7aY4vg#wgENvC
 */
import { AcoFormData, FullNormalFormData, AdgroupFormData, CREATIVE_TYPE } from '@tt4b/ttam-enums';
import {
  StateEnum,
  useStore,
  useTrackSmartTitleSuggestionApi,
  useTrackSubmitSmartTitleSuggestionApi,
  useStdCreativeAdgroupIs
} from '@tt4b/ttam-hooks';
import { computed, Ref } from '@vue/composition-api';

// 保存请求标题建议接口的历史信息，用于埋点上报
const requestHistorySet = new Set<{ requestId: string; titles: { title: ''; matchKeywords: [] }[] }>();
let isShowTitleSuggestion = false; // 是否展示过标题建议

export const useTrackTitleSuggestion = (opt: {
  adgroupData: Ref<AdgroupFormData>;
  creativeData: Ref<Partial<FullNormalFormData & AcoFormData>>;
}) => {
  const { adgroupData, creativeData } = opt;
  const { state } = useStore();
  const aadvid = computed(() => state[StateEnum.baseInfo].value.aadvid);
  const isAco = computed(() => adgroupData.value.creativeMaterialMode === CREATIVE_TYPE.PROCEDURAL);

  /**
   * 记录请求信息
   */
  const addRequestInfo = data => {
    if (data?.requestId) {
      requestHistorySet.add(data);
      isShowTitleSuggestion = true;
    }
  };

  /**
   * 编辑器失去焦点时上报
   * 1. 选中建议标题时上报
   * 2. 不选中国年建议标题，直接失去焦点上报
   */
  const trackSelectSuggestion = ({ title = '', isBlur = false }) => {
    let requestIds = [...requestHistorySet].map(item => item.requestId) || [];
    requestIds = requestIds.filter(id => Boolean(id));
    if (!requestIds.length) {
      return;
    }
    const selectedTitles = [{ request_id: requestIds[requestIds.length - 1], adopt_title: title }];
    const param = {
      adv_id: aadvid.value,
      ad_id: adgroupData.value.adId || '',
      request_ids: requestIds,
      selected_suggestions: isBlur ? [] : selectedTitles,
    };
    useTrackSmartTitleSuggestionApi(param);
    requestHistorySet.clear();
  };

  /**
   * 创编提交时的埋点
   * 最后一次选中的标题建议
   * @param {String} adId 提交时，接口返回的adgroupId
   */
  const trackSubmitTitleSuggestion = (adId = '') => {
    const params = {
      adv_id: aadvid.value,
      ad_id: adId,
      request_ids: [],
      selected_titles: [],
      user_titles: [],
      is_click: isShowTitleSuggestion ? 1 : 0, // 标题续写有过建议则为1，否则为0
    };
    // eslint-disable-next-line camelcase
    const selectedTitles: { request_id: string; origin_title: string; title: string }[] = [];
    const userTitles: string[] = [];
    if (isAco.value) {
      const titleList = creativeData.value.titleList || [];
      titleList.forEach(item => {
        userTitles.push(item.title || '');
        selectedTitles.push({
          request_id: item.titleSuggestionInfo?.requestId || '',
          title: item.title || '',
          origin_title: item.titleSuggestionInfo?.title || '',
        });
      });
    } else {
      userTitles.push(creativeData.value.title || '');
      selectedTitles.push({
        request_id: creativeData.value.titleSuggestionInfo?.requestId || '',
        origin_title: creativeData.value.titleSuggestionInfo?.title || '',
        title: creativeData.value.title || '',
      });
    }
    params.selected_titles = selectedTitles;
    params.request_ids = selectedTitles.map(item => item.request_id).filter(id => Boolean(id));
    params.user_titles = userTitles;
    useTrackSubmitSmartTitleSuggestionApi(params);
  };

  return {
    addRequestInfo,
    trackSelectSuggestion,
    trackSubmitTitleSuggestion,
  };
};
